import { Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Facebook, Instagram, Twitter, Link, SvgIconComponent } from "@mui/icons-material";
import { Fragment } from "react";
import { combineURLs } from "../../utils";
import { FACEBOOK_BASEURL, INSTAGRAM_BASEURL, TWITTER_BASEURL } from "../../constants";

interface Props {
  facebook_id?: string | null;
  twitter_id?: string | null;
  instagram_id?: string | null;
  website?: string | null;
}

const useStyles = makeStyles((theme) => ({
  root_SocialMediaBlock: {
    paddingTop: 5, // this should probably be passed in
  },
  link: {
    paddingLeft: 5,
    "&:first-child": {
      paddingLeft: 0,
    },
  },
  toolTip: {
    margin: "4px 0",
  },
}));

const tips = {
  facebook_id: "Facebook",
  instagram_id: "Instagram",
  twitter_id: "Twitter",
  website: "Website",
};

export const SocialMediaBlock: React.FC<Props> = ({ facebook_id, instagram_id, twitter_id, website }) => {
  const classes = useStyles();
  const iconColor = "#FAF9F6";

  const elements: { url: string; Element: SvgIconComponent; tip: string }[] = [];

  if (instagram_id) {
    elements.push({
      url: combineURLs(INSTAGRAM_BASEURL, instagram_id),
      Element: Instagram,
      tip: tips.instagram_id,
    });
  }

  if (twitter_id) {
    elements.push({
      url: combineURLs(TWITTER_BASEURL, twitter_id),
      Element: Twitter,
      tip: tips.twitter_id,
    });
  }

  if (facebook_id) {
    elements.push({
      url: combineURLs(FACEBOOK_BASEURL, facebook_id),
      Element: Facebook,
      tip: tips.facebook_id,
    });
  }

  if (website) {
    elements.push({
      url: website,
      Element: Link,
      // Element: () => <Link style={{ transform: "rotate(90deg)" }} />,
      tip: tips.website,
    });
  }

  return (
    <div className={classes.root_SocialMediaBlock}>
      {elements.map((elm) => (
        <Fragment key={elm.url}>
          <Tooltip arrow title={elm.tip} classes={{ tooltip: classes.toolTip }}>
            <a className={classes.link} target="_blank" rel="noreferrer" href={elm.url}>
              <elm.Element fontSize="large" htmlColor={iconColor} />
            </a>
          </Tooltip>
        </Fragment>
      ))}
    </div>
  );
};

export default SocialMediaBlock;
